module.exports = __webpack_public_path__ + "img/topic3-2.438cd305.png";